import { render, staticRenderFns } from "./ChainsMilestones.vue?vue&type=template&id=b1ec2914&scoped=true&"
import script from "./ChainsMilestones.vue?vue&type=script&lang=ts&"
export * from "./ChainsMilestones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ec2914",
  null
  
)

export default component.exports